import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './menu-icons.css';


const CrossIcon = props => {
    const { fill, className, onClick } = props;
    const [hover, setHover] = useState(false);
    const toggleHover = flag => {
        setHover(flag);
    }
    return (
        <svg
            viewBox="0 0 24 24"
            height="25px"
            width="25px"
            className={`rotate ${className}`}
            onMouseEnter={() => toggleHover(true)}
            onMouseLeave={() => toggleHover(false)}
            onClick={onClick}
        >
            <path d="M13.3333333,10.6666667 L18.6666667,10.6666667 C19.4030463,10.6666667 20,11.2636203 20,12 C20,12.7363797 19.4030463,13.3333333 18.6666667,13.3333333 L13.3333333,13.3333333 L13.3333333,18.6666667 C13.3333333,19.4030463 12.7363797,20 12,20 C11.2636203,20 10.6666667,19.4030463 10.6666667,18.6666667 L10.6666667,13.3333333 L5.33333333,13.3333333 C4.59695367,13.3333333 4,12.7363797 4,12 C4,11.2636203 4.59695367,10.6666667 5.33333333,10.6666667 L10.6666667,10.6666667 L10.6666667,5.33333333 C10.6666667,4.59695367 11.2636203,4 12,4 C12.7363797,4 13.3333333,4.59695367 13.3333333,5.33333333 L13.3333333,10.6666667 Z" id="Path" fill={hover ? "#000000" : fill ? fill : "#FE4242"} fillRule="evenodd"></path>
        </svg>
    );
};

// CrossIcon.propTypes = {
//   active: PropTypes.bool.isRequired,
//   label: PropTypes.bool.isRequired,
// };

export default CrossIcon;
